import moment from 'moment';

function extractFeatures(features, maxCount) {
  // rearrange array for manipulations
  const result = {
    featureObj: [],
    maxCount,
  };
  Object.keys(features).forEach(x => {
    if (features[x].Count && !Number.isNaN(features[x].Count)) {
      result.featureObj.push({ key: x, value: features[x].Count, filtId: features[x].ID });
      if (Number(features[x].Count) > maxCount) result.maxCount = Number(features[x].Count);
    } else {
      result.featureObj.push({ key: x, value: 0 });
    }
  });
  return [result.featureObj, result.maxCount];
}

function getMonthDayLabelFromEpoch(date) {
  return moment.unix(date).format('D MMM');
}

function generateRandomBuild(
  captionArray = ['C++', 'C#', 'VisualStudio', 'Playstation', 'XBox', '', 'Aliens'],
  agentsArray = ['yair', 'yehuda', 'yftah', 'galit', 'israel', 'moshka', ''],
  minDuration = 50,
  maxDuration = 250,
) {
  return {
    Caption: captionArray[Math.floor(Math.random() * captionArray.length)],
    Duration: Math.floor(Math.random() * (maxDuration - minDuration) + minDuration),
    Initiator: agentsArray[Math.floor(Math.random() * agentsArray.length)],
  };
}

export const Mutations = {
  // implement MUTATIONS here...
  SET_DATASET_HIDDEN_STATE(state, payload) {
    state[payload.chartName].data.datasets[payload.idx].dataHidden = payload.newState;
    // eslint-disable-next-line no-underscore-dangle
    state[payload.chartName].data.datasets[payload.idx]._meta[Object.keys(state[payload.chartName].data.datasets[payload.idx]._meta)[0]].hidden = payload.newState;
  },
  ADD_DATA_TO_CHART(state, payload) {
    state[payload.chartName].data.datasets[payload.idx].data.push(Math.floor(Math.random() * 11));
    state[payload.chartName].data.labels.push(Math.floor(Math.random() * 11));
  },
  setTelemetryActiveInfo(state, payload) {
    state.telemetryActiveInfo = payload;
  },
  setChartTelemetryActiveInfoHour(state, payload) {
    const workloads = [];
    const cloudactive = [];
    const onpremactive = [];
    const totalavailable = [];
    const totalAvailableStacked = [];
    let labels = [];
    const activeBuilds = payload === 'testingData' ? state?.slide2TestData?.Builds : payload?.Builds;
    const cores = payload === 'testingData' ? state?.slide2TestData?.Cores : payload?.Cores;
    if (cores && Object.keys(cores) && Object.keys(cores).length > 0) {
      // not empty, has labels, we can start
      labels = Object.keys(cores);
      labels.forEach(datadot => {
        if (activeBuilds && activeBuilds[datadot]) workloads.push(activeBuilds[datadot]);
        // workload
        else workloads.push(0);
        const activeCloud = cores[datadot].Active.Cloud;
        const activeOnPrem = cores[datadot].Active.Floating + cores[datadot].Active.Named;
        cloudactive.push(activeCloud); // cloud
        onpremactive.push(activeOnPrem); // on prem
        const totalCores = Math.max(cores[datadot].Total.Cloud + cores[datadot].Total.Floating + cores[datadot].Total.Named, 0);
        totalavailable.push(totalCores); // total
        totalAvailableStacked.push(Math.max(totalCores - activeCloud - activeOnPrem, 0));
      });
      if (labels) {
        state.coordinatorUtilizationChart.data.labels = labels;
        state.coordinatorUtilizationChart0 = workloads;
        state.coordinatorUtilizationChart1 = cloudactive;
        state.coordinatorUtilizationChart2 = onpremactive;
        state.coordinatorUtilizationChart3 = totalavailable;
        state.coordinatorUtilizationChart3stacked = totalAvailableStacked;
      }
    }
  },
  setChartTelemetryCoresUsagePerDay(state, payload) {
    // let datasets = state.dailyCoresUsageDataset.data.datasets;
    const datasetMAX = [];
    const datasetAVG = [];
    const labels = [];
    const coresUsage = payload === 'testingData' ? state.slide3TestData : payload;
    if (coresUsage && Object.keys(coresUsage) && Object.keys(coresUsage).length > 0) {
      Object.keys(coresUsage).forEach(dayData => {
        labels.push(getMonthDayLabelFromEpoch(coresUsage[dayData].Time));
        // labels.push(getMonthDayLabel(coresUsage[dayData].Time)); // string
        datasetMAX.push(coresUsage[dayData].MAX);
        datasetAVG.push(Number(coresUsage[dayData].AVG).toFixed());
      });
      state.dailyCoresUsageChart.data.datasets[0].data = datasetMAX;
      state.dailyCoresUsageChart.data.datasets[1].data = datasetAVG;
      state.dailyCoresUsageChart.data.labels = labels;
      // state.dailyCoresUsageChart = {...state.dailyCoresUsageChart};
    }
  },
  setChartTelemetryWorkloadUtilization(state, payload) {
    const slideObj = { maxCount: 10, buildCaptionList: [], agentsList: [] };

    const utilisedFeatures = payload === 'testingData' ? state.slide4TestData.UtilisedFeatures : payload.UtilisedFeatures;
    const missingFeatures = payload === 'testingData' ? state.slide4TestData.MissingFeatures : payload.MissingFeatures;

    if (utilisedFeatures && Object.keys(utilisedFeatures)) {
      [slideObj.utilized, slideObj.maxCount] = extractFeatures(utilisedFeatures, slideObj.maxCount);
    }
    if (missingFeatures && Object.keys(missingFeatures)) {
      [slideObj.unutilized, slideObj.maxCount] = extractFeatures(missingFeatures, slideObj.maxCount);
    }
    state.workloadUtilizationDataset = slideObj;
    if (payload.timeRange) {
      // update timerange if needed.
      state.slide4Filters.timeRange = payload.timeRange;
    }
  },
  setChartTelemetryWorkloadUtilizationSetFilters(state, payload) {
    const slideObj = { maxCount: 10, buildCaptionList: [], agentsList: [] };
    let featureFilters = [];
    const distinctBuilds = payload === 'testingData' ? state.slide4TestData.DistinctBuilds : payload.DistinctBuilds;
    const distinctInitiators = payload === 'testingData' ? state.slide4TestData.DistinctInitiators : payload.DistinctInitiators;
    const utilisedFeatures = payload === 'testingData' ? state.slide4TestData.UtilisedFeatures : payload.UtilisedFeatures;
    const missingFeatures = payload === 'testingData' ? state.slide4TestData.MissingFeatures : payload.MissingFeatures;
    // get some stuff
    featureFilters = [
      ...(utilisedFeatures && Object.keys(utilisedFeatures) ? Object.keys(utilisedFeatures) : []),
      ...(missingFeatures && Object.keys(missingFeatures) ? Object.keys(missingFeatures) : []),
    ];
    // eslint-disable-next-line no-multi-assign
    if (featureFilters && featureFilters.length > 0) slideObj.featureFilters = featureFilters = [...new Set(featureFilters)];

    if (distinctBuilds && Object.keys(distinctBuilds)) {
      Object.keys(distinctBuilds).forEach(x => {
        if (!x && !slideObj.buildCaptionList.includes('No Caption')) slideObj.buildCaptionList.push('No Caption');
        else if (!slideObj.buildCaptionList.includes(x)) slideObj.buildCaptionList.push(x);
      });
    }
    if (distinctInitiators && Array.isArray(distinctInitiators) && distinctInitiators.length > 0) {
      slideObj.agentsList = distinctInitiators;
    }
    state.slide4Filters.agents_filt_options = slideObj.agentsList;
    state.slide4Filters.build_caption_filt_options = slideObj.buildCaptionList;
    state.slide4Filters.features_filt_options = featureFilters;

    // setup time.
    if (payload.start_ts) state.slide4Filters.timeRangeForList.from = payload.start_ts;
    if (payload.end_ts) state.slide4Filters.timeRangeForList.to = payload.end_ts;
  },
  setChartTelemetryWorkloadUtilizationDrilldown(state, payload) {
    const slide4DrilldownObj = payload;
    // slide4DrilldownObj.feature_name = state.slide4Filters.feature_name;
    slide4DrilldownObj.feature = state.slide4Filters.feature;
    state.workloadUtilizationDatasetDrilldown = slide4DrilldownObj;
  },
  setSlide4Filters(state, payload) {
    if (payload.isList && payload.featureList) {
      payload.featureList.forEach(x => {
        if (x.field) state.slide4Filters[x.field] = x.value;
      });
    } else if (payload.field) {
      state.slide4Filters[payload.field] = payload.value;
    }
  },
  setChartTelemetryBuildsDuration(state, payload) {
    const slideObj = { captionList: [], agentList: [], agentMap: {} };
    const tempData = {};
    if (payload === 'testingData') {
      for (let i = 0; i < 100; i++) {
        tempData[i] = generateRandomBuild();
      }
    }
    const builds = payload === 'testingData' ? tempData : payload.Builds; // state.slide5TestData.Builds
    if (builds && Object.keys(builds) && Object.keys(builds).length > 0) {
      slideObj.builds = builds;
      Object.keys(builds).forEach(x => {
        if (!builds[x].Caption) builds[x].Caption = 'No Caption';
        if (!builds[x].Initiator || !builds[x].Initiator.Name) builds[x].InitiatorName = 'No Initiator';
        else builds[x].InitiatorName = builds[x].Initiator.Name;
        const capt = builds[x].Caption; // || 'No Caption';
        const agent = builds[x].InitiatorName; // || 'No Initiator';
        if (capt && !slideObj.captionList.includes(capt)) slideObj.captionList.push(capt);
        if (agent && !slideObj.agentList.includes(agent)) {
          slideObj.agentList.push(agent);
          slideObj.agentMap[agent] = builds[x].Initiator?.ID;
        }
      });
    }
    // set filters
    state.slide5Filters.build_captions = slideObj.captionList;
    state.slide5Filters.agent_names = slideObj.agentList;
    state.workloadsByDataset = slideObj;
  },
  setChartTelemetryBuildsDurationDrilldownBuilds(state, payload) {
    // do we even need this in state?
    const slideObj = { buildsArray: [] };
    // not sure what to filter, so mostly placeholder here - TODO - complete this once known.
    const builds = payload.Builds;
    if (builds && Object.keys(builds) && Object.keys(builds).length > 0) {
      Object.keys(builds).forEach(x => {
        builds[x].expand = false;
        // builds[x].buildId = x; // comes in BuildID field
        slideObj.buildsArray.push(builds[x]);
      });
    }
    slideObj.feature = state.slide5Filters.feature;
    state.workloadsByDatasetDrilldownBuilds = slideObj;
    return slideObj;
  },
  setChartTelemetryBuildsDurationDrilldownHelpers(state, payload) {
    if (payload.build_id && payload.helpers) {
      if (!state.workloadsByDatasetDrilldownHelpers) state.workloadsByDatasetDrilldownHelpers = {};
      state.workloadsByDatasetDrilldownHelpers[payload.build_id] = payload.helpers;
      return payload.helpers;
    }
    return null;
  },
  setSlide5Filters(state, payload) {
    if (payload.isList && payload.featureList) {
      payload.featureList.forEach(x => {
        if (x.field) state.slide5Filters[x.field] = x.value;
      });
    } else if (payload.field) {
      state.slide5Filters[payload.field] = payload.value;
    }
  },
  setChartTelemetryAgentsUtilization(state, payload) {
    const slideObj = {
      // maxCoresCount: 2, maxDurationCount: 100,
      agentsList: [],
    };

    const agents = payload && payload.Agents ? payload.Agents : [];
    Object.keys(agents).forEach(x => {
      const data = agents[x];
      // if(data.NumberOfCores > slideObj.maxCoresCount)
      //   slideObj.maxCoresCount = data.NumberOfCores;
      // max time... just as right now we are getting 0...
      const maxDuration = data.TotalTime > data.DurationAsHelper + data.DurationAsInitiator ? data.TotalTime : data.DurationAsHelper + data.DurationAsInitiator;
      // if(maxDuration > slideObj.maxDurationCount)
      //   slideObj.maxDurationCount = maxDuration;
      slideObj.agentsList.push({
        agent: data.Name,
        availableTime: data.AvailableTime,
        avgCores: data.AvgCores,
        durationAsHelper: data.DurationAsHelper,
        durationAsInitiator: data.DurationAsInitiator,
        numberOfCores: data.NumberOfCores || 1, // Diana - why min cores number is 1 and not something real, mispar zugi
        totalTime: maxDuration, // will use data if it starts giving data.
      });
    });
    state.agentsUtilizationChart = slideObj;
  },
  setChartTelemetryAgentsUtilizationSetFilters(state, payload) {
    if (payload && Object.prototype.hasOwnProperty.call(payload, 'Titles')) {
      state.agentsUtilizationChartFilters.captionList = payload.Titles;
      state.agentsUtilizationChartFilters.build_captions = payload.Titles;
    }
    if (payload && Object.prototype.hasOwnProperty.call(payload, 'Groups')) {
      state.agentsUtilizationChartFilters.groupsList = payload.Groups;
      state.agentsUtilizationChartFilters.build_groups = payload.Groups;
    }

    // setup time.
    if (payload.start_ts) state.agentsUtilizationChartFilters.timeRangeForList.from = payload.start_ts;
    if (payload.end_ts) state.agentsUtilizationChartFilters.timeRangeForList.to = payload.end_ts;
  },
  setFilters(state, payload) {
    if (payload.filterObj) {
      if (payload.listToUpdate && Array.isArray(payload.listToUpdate)) {
        payload.listToUpdate.forEach(x => {
          if (x.field) state[payload.filterObj][x.field] = x.value;
        });
      } else if (payload.field) {
        state[payload.filterObj][payload.field] = payload.value;
      }
    }
  },
};
